export const SEL_RECRUITING = "SEL_RECRUITING";
export const ALL_RECRUITING = "ALL_RECRUITING";
export const RECRUITING_COUNT = "RECRUITING_COUNT";

export const SEL_CARRIER = "SEL_CARRIER";
export const ALL_CARRIER = "ALL_CARRIER";
export const CARRIER_COUNT = "CARRIER_COUNT";
